import { lazy, Suspense } from 'react';
import { z } from 'zod';
import { Timer } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import { useDashboardMetric } from '@/hooks/use-dashboard-metric';
import type { TileDefinition } from './types';

/**
 * Lazy import — even though TimeToResolutionTile doesn't pull Recharts
 * directly, it's bundled in the same dashboard chunk family. Lazy
 * loading keeps the dashboard route's initial paint fast.
 */
const TimeToResolutionTile = lazy(() =>
  import('../time-to-resolution-tile').then((m) => ({ default: m.TimeToResolutionTile }))
);

export const timeToResolutionTile: TileDefinition = {
  type: 'time_to_resolution_by_label',
  title: 'Time to resolution',
  description: 'Per-label median, p90, and over-target distribution.',
  icon: Timer,
  metrics: ['time_to_resolution_by_label'],
  defaultSize: { w: 6, h: 4 },
  minSize: { w: 4, h: 3 },
  configSchema: z.object({}).strict(),
  defaultConfig: {},
  render: ({ period, enabled }) => {
    const { metric, isLoading, isError } = useDashboardMetric({
      metricKey: 'time_to_resolution_by_label',
      from: period.from,
      to: period.to,
      enabled,
    });
    return (
      <Suspense
        fallback={
          <div className="flex h-full flex-col gap-2">
            <Skeleton className="h-7 w-full" />
            <Skeleton className="h-7 w-full" />
            <Skeleton className="h-7 w-full" />
          </div>
        }
      >
        <TimeToResolutionTile items={metric?.items} isLoading={isLoading} isError={isError} />
      </Suspense>
    );
  },
};
